// Millie mascot assets, meal imagery and helper captions.
export const MILLIE = {
  home: "https://customer-assets-gfyr7b9c.emergentagent.net/job_millie-meal-planner/artifacts/pa8se9iw_ChatGPT%20Image%20Sep%2024%2C%202026%2C%2001_45_55%20PM.png",
  avatar: "https://customer-assets-gfyr7b9c.emergentagent.net/job_millie-meal-planner/artifacts/pa8se9iw_ChatGPT%20Image%20Sep%2024%2C%202026%2C%2001_45_55%20PM.png",
  thumbsup: "https://customer-assets-gfyr7b9c.emergentagent.net/job_millie-meal-planner/artifacts/pa8se9iw_ChatGPT%20Image%20Sep%2024%2C%202026%2C%2001_45_55%20PM.png",
};

export const MILLIE_AVATAR = MILLIE.avatar;

export const MEAL_IMAGES = {
  healthy_dinner_1:
    "https://images.unsplash.com/photo-1592417817038-d13fd7342605?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxoZWFsdGh5JTIwZmFtaWx5JTIwZGlubmVyJTIwbWVhbHxlbnwwfHx8fDE3OTAyMTc3MDh8MA&ixlib=rb-4.1.0&q=85",
  healthy_dinner_2:
    "https://images.pexels.com/photos/30175746/pexels-photo-30175746.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const GROCERIES_IMG =
  "https://images.pexels.com/photos/7129143/pexels-photo-7129143.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const TAKEAWAY_IMG =
  "https://images.unsplash.com/photo-1609795829951-325b91a41471?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMHRha2Vhd2F5JTIwYm94fGVufDB8fHx8MTc5MDIxNzcwOHww&ixlib=rb-4.1.0&q=85";

export function mealImage(key) {
  return MEAL_IMAGES[key] || MEAL_IMAGES.healthy_dinner_1;
}

// Expression set (sliced from the user's artwork sheet). Keys are moods used across the app.
export const MOODS = {
  happy: "/millie/laugh.png",
  wink: "/millie/wink.png",
  thinking: "/millie/thinking.png",
  celebrate: "/millie/thumbsup.png",
  surprised: "/millie/surprised.png",
  love: "/millie/kiss.png",
  cooking: "/millie/cooking.png",
  oops: "/millie/oops.png",
  idea: "/millie/idea.png",
  sleepy: "/millie/dreamy.png",
  cosy: "/millie/cosy.png",
  point: "/millie/point.png",
};

export function moodForHour(h = new Date().getHours()) {
  if (h < 10) return "cosy";
  if (h >= 21) return "sleepy";
  return "happy";
}
